import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

const today = new Date();
const gg = 30;
today.setHours(0, 0, 0, 0); // Rimuovo il tempo dall'oggetto Date per confrontare solo le date

const startDate = new Date(today.setDate(today.getDate() + gg));

const startDate2 = new Date(today.setDate(today.getDate()));

const filterDate = (d: Date | null): boolean => {
    return d !== null && d > startDate;
};

const filterDate2 = (d: Date | null): boolean => {
    return d !== null && d > startDate2;
};

export const RichiestaPassoCarraioStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-2 gap-4',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-2',
                key: 'jd.tipo_occupazione',
                type:'mat-select',
                props: {
                    label: 'TIPO DI OCCUPAZIONE',
                    required: true,
                    options: [
                        {
                            value: 'permanente',
                            label: 'OCCUPAZIONE PERMANENTE',
                        },
                        {
                            value: 'temporanea',
                            label: 'OCCUPAZIONE TEMPORANEA',
                        },
                    ],
                },
            },
        ],
    },
    {
        key: 'jd.autorizzata_dal',
        type: '#data',
        props: {
            label: 'DATA INIZIO',
            required: true,
            datepickerOptions: {
                startAt: startDate,
                filter: filterDate
            },

        },
        validators: {
            datemin: {
                expression: (c: AbstractControl) =>
                    new Date(c.value) >= startDate,
                message: (
                    error: any,
                    field: FormlyFieldConfig,
                ) =>
                    `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
            },
        },
        expressions: {
            hide: "model.jd.tipo_occupazione != 'permanente'",
        },
  },
    {
        fieldGroup: [
                {
                    wrappers: ['group-panel'],
                    key: 'jd.periodo_occupazione',
                    type: 'repeat',
                    defaultValue: [],
                    fieldGroupClassName:
                        'flex flex-col border border-t-4 border-t-primary shadow-sm rounded-xl mb-6 mt-4 w-full',
                    props: {
                        addText: 'AGGIUNGI PERIODO *',
                        label:'PERIODO DI OCCUPAZIONE'
                    },
                fieldArray: {
                    fieldGroupClassName:
                    'border border-t-4 p-4 shadow-sm rounded-xl mb-2 grid md:grid-cols-4 sm:grid-cols-1 gap-4',
                fieldGroup: [
                        {
                            className: 'sm:col-span-1 md:col-span-1',
                            key: 'data_inizio',
                            type: '#data',
                            props: {
                                label: 'DATA INIZIO',
                                datepickerOptions: {
                                    startAt: startDate,
                                    filter: filterDate,
                                },
                            },
                            validators: {
                                datemin: {
                                    expression: (c: AbstractControl) =>
                                        new Date(c.value) >= startDate,
                                    message: (
                                        error: any,
                                        field: FormlyFieldConfig,
                                    ) =>
                                        `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                                },
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-1',
                            key: 'data_fine',
                            type: '#data',
                            props: {
                                label: 'DATA FINE',
                                datepickerOptions: {
                                    startAt: startDate,
                                    filter: filterDate,
                                },
                            },
                            validators: {
                                datemin: {
                                    expression: (c: AbstractControl) =>
                                        new Date(c.value) >= startDate,
                                    message: (
                                        error: any,
                                        field: FormlyFieldConfig,
                                    ) =>
                                        `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                                },
                            },
                        },
                    ],
                    validators: {
                      validation: [{ name: 'dateRangeValidator', options: { start:'data_inizio', end:'data_fine', errorPath: 'data_fine', message: 'La data di fine deve essere successiva alla data di inizio' } }],
                  },
                },
            },
        ],
        expressions: {
            hide: "model.jd.tipo_occupazione != 'temporanea'",
        },
    },
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-2 gap-4',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-2',
                key: 'jd.rinnovo_opt',
                type:'mat-radio',
                props: {
                    label: 'RINNOVO DI PRECEDENTE AUTORIZZAZIONE NON PRESENTATA ONLINE',
                    required: true,
                    color: 'primary',
                    options: [
                        { value: 'si', label: 'SI' },
                        { value: 'no', label: 'NO' },
                    ],
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.documento_esistente_autorizzazione',
                type:'mat-input',
                props: {
                    label: 'NUMERO DI AUTORIZZAZIONE DA RINNOVARE',
                    type: 'number',
                    required: true,
                },
                expressions: {
                    hide: "model.jd.rinnovo_opt != 'si'",
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.documento_esistente_data',
                type: '#data',
                props: {
                    label: 'DATA AUTORIZZAZIONE',
                    required: true,
                    datepickerOptions: {
                        startAt: startDate,
                    },
                },
                expressions: {
                    hide: "model.jd.rinnovo_opt != 'si'",
                },
            },
        ],
    },
];
